<template>
  <div>
    <PopupPage :subtitle1="1" v-show="isLang === 0" />
    <main-slider />
    <NoticeBar v-show="isLang === 0" />
    <div class="spacing"></div>
    <Architecturepodo />
    <div class="spacing"></div>
    <SpecialOffers v-show="isLang === 0" />
    <div class="spacing"></div>
    <!--
    <Dining :show-title="true" v-show="isLang === 0" />
    <div class="spacing"></div>
    -->
    <Newsroom v-show="isLang === 0" />
    <div class="spacing"></div>
  </div>
</template>

<script>
import MainSlider from './Components/MainSlider';
import NoticeBar from '@/pages/MainPage/Components/NoticeBar';
import Architecturepodo from './Components/Architecturepodo';
import SpecialOffers from './Components/SpecialOffers';
// import Dining from './Components/Dining';
import Newsroom from '@/pages/MainPage/Components/Newsroom';
import PopupPage from '@/pages/Popup/PopupPage.vue';

export default {
  name: 'MainPage',
  components: {MainSlider, Architecturepodo, SpecialOffers, NoticeBar, Newsroom, PopupPage},
  data() {
    return {
      isLang: 0,
    };
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      console.log();
    });
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
};
</script>

<style scoped lang="scss">
.spacing {
  height: 5rem;
}
</style>
